export const SalesVolumeTypesHistory = {
  IGetSalesVolumeServiceHistory: Symbol("IGetSalesVolumeServiceHistory"),
};
